import { observer } from 'mobx-react';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { cashbackStore } from '../../store/cashbackStore';
import { DEBOUNCE_TIME, STATUS_FILTER } from 'src/constants/main';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Picker from 'src/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import './style.scss';

enum CASHBACK_STATUS_FILTER {
  ALL = 'all',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PLANNED = 'planned',
  EXPIRED = 'expired',
}

const CashbackHeader: FC = observer((): JSX.Element => {
  const statusOptions: IPickerOption[] = [
    { label: localeStore.t(STATUS_FILTER.ALL), value: CASHBACK_STATUS_FILTER.ALL },
    { label: localeStore.t(STATUS_FILTER.ACTIVE), value: CASHBACK_STATUS_FILTER.ACTIVE },
    { label: localeStore.t(STATUS_FILTER.INACTIVE), value: CASHBACK_STATUS_FILTER.INACTIVE },
    { label: localeStore.t(STATUS_FILTER.PLANNED), value: CASHBACK_STATUS_FILTER.PLANNED },
    { label: localeStore.t(STATUS_FILTER.EXPIRED), value: CASHBACK_STATUS_FILTER.EXPIRED },
  ];

  const handleSearch = (search: string) => {
    cashbackStore.setFilters({ search }, false);
  };

  const handleStatusChange = (options: IPickerOption[]) => {
    const statusOption = options?.[0];
    cashbackStore.setFilters({ statusOption }, false);
  };

  return (
    <div className="d-flex flex-row justify-content-between pr-4">
      <div className="d-flex flex-start">
        <SearchInput
          value={cashbackStore.filters.search}
          onChangeText={handleSearch}
          loading={cashbackStore.isLoading}
          debounceDelay={DEBOUNCE_TIME.MEDIUM}
          placeholder="txt_search"
          customPlaceholder
          withResetIcon
          className="cashback-header__search-input mr-2"
          inputClassName="pl-3 pr-7 color-dark text-size-16 family-medium"
        />
        <Picker
          options={statusOptions}
          selectedOptions={cashbackStore.filters.statusOption ? [cashbackStore.filters.statusOption] : []}
          onSelect={handleStatusChange}
          placeholder={localeStore.t('txt_delivery_status_h')}
          className="mr-2"
          listClassName="full-width"
        />
      </div>
      <Link to={SCREENS.CASHBACK_CREATE()}>
        <Button title={localeStore.t('create_cashback')} loading={cashbackStore.isLoading} />
      </Link>
    </div>
  );
});

export default CashbackHeader;
